import { captureException, captureMessage, captureWarning, CaptureContext } from "../../sentry"

const Logger = {
  logError: (error: Error) => {
    console.error(error)
    captureException(error)
  },
  logMessage: (message: string) => {
    console.info(message)
    captureMessage(message)
  },
  logWarning: (message: string, context?: CaptureContext) => {
    console.warn(message, context)
    captureWarning(message, context)
  }
}

export default Logger
